<app-header
  [text]="'MOT.VACATIONS_REQUEST_MENU_LINK' | translate"
  [scrollArea]="myContent"
  (back)="checkProposalChanges()"></app-header>

<app-content #myContent>
  <div class="grid-fixed">
    <div class="row">
      <div class="col" size="12" size-md="8" offset-md="2">
        <div class="content">
          <app-title-section
            [text]="'MOT.VACATIONS_REQUEST_MENU_LINK' | translate"
            (back)="checkProposalChanges()"></app-title-section>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col" size="12" size-md="8" offset-md="2">
        <p class="title">{{ 'MANAGE_VACATIONS.EDIT_PROPOSALS_TITLE' | translate }}</p>

        <div class="card-container" *ngFor="let proposal of seasonProposal?.proposalsByOrder; trackBy: trackByItems">
          <app-proposals-actions-card
            [proposalsByOrder]="proposal"
            [season]="seasonProposal.id"
            (actionClicked)="onActionClicked(proposal, $event)"></app-proposals-actions-card>
        </div>
      </div>
    </div>

    <footer>
      <button class="c-button primary" [disabled]="disableButton" (click)="saveChanges()">
        {{ 'MANAGE_VACATIONS.SEND_PROPOSAL' | translate }}
      </button>
    </footer>
  </div>
</app-content>
